import AbsenceRequestConflictsCard from './absence-request-conflict-card'

export default AbsenceRequestConflictsCard
